// store.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import queryParamsReducer from './queryParamsSlice';
import shouldFetchReducer from './shouldFetchSlice';
import recStartedReducer from './recStartedSlice';
import recMachStartedReducer from './recMachStartedSlice';
import procGridReducer from './procGridSlice';
import procsReducer from './procsSlice';
import defectTypesReducer from './defectTypesSlice';
import notificationsReducer from './notificationsSlice';
import memberReducer from './memberSlice';
import suspensionReasonsSliceReducer from './suspensionReasonsSlice';
import procListLayoutReducer from './procListLayoutSlice';
import controllerStateSliceReducer from './controllerStateSlice';
import defectsReducer from './defectsSlice';
import defectsListReducer from './defectsListSlice';
import defectReportAttachementSlice from './defectReportAttachementSlice';
import defectReportsReviewsReducer from './defectReportsReviewsSlice';
import alertReducer from './alertSlice';
import temperingScheduleReducer from './temperingScheduleSlice';

const rootReducer = combineReducers({
  user: userReducer,
  queryParams: queryParamsReducer,
  shouldFetch: shouldFetchReducer,
  recStarted: recStartedReducer,
  recMachStarted: recMachStartedReducer,
  procGrid: procGridReducer,
  procs: procsReducer,
  defectTypes: defectTypesReducer,
  suspensionReasons: suspensionReasonsSliceReducer,
  notifications: notificationsReducer,
  member: memberReducer,
  procListLayout: procListLayoutReducer,
  controllerState: controllerStateSliceReducer,
  defects:defectsReducer,
  defectsList:defectsListReducer,
  defectReportAttachement:defectReportAttachementSlice,
  defectReportsReviews: defectReportsReviewsReducer,
  alert: alertReducer,
  temperingSchedule: temperingScheduleReducer,
})

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
